const FavoriteIcon = ({ color, border }: { color: string, border: string }) => {
    return <svg xmlns="http://www.w3.org/2000/svg" width="34" height="31" viewBox="0 0 34 31" fill="none">
        <path
            d="M23.2334 1.125C28.78 1.125 32.5069 6.40453 32.5069 11.3297C32.5069 21.3041 17.0393 29.4715 16.7593 29.4715C16.4794 29.4715 1.01172 21.3041 1.01172 11.3297C1.01172 6.40453 4.73865 1.125 10.2853 1.125C13.4698 1.125 15.552 2.7372 16.7593 4.15453C17.9667 2.7372 20.0488 1.125 23.2334 1.125Z"
            stroke={border}
            strokeWidth="1.5748"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill={color} />
    </svg>
}

export default FavoriteIcon